import { render, staticRenderFns } from "./feature-dialog.vue?vue&type=template&id=04a12d80&"
import script from "./feature-dialog.vue?vue&type=script&lang=js&"
export * from "./feature-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports